import {LOAD_OSD_VIEWER_CONFIG, UPDATE_OSD_VIEWER_CONFIG} from "../redux_constants/osd.viewer.config.constant";

const initialState = {
	loaded: false,
	global: {},
	organisation: {},
	user: {},
	permissions: {},
};

export const osdViewerConfigReducer = (state = initialState, action) => {
	switch (action.type) {

		case LOAD_OSD_VIEWER_CONFIG:
			return {...initialState, ...action.config, loaded: true};

		case UPDATE_OSD_VIEWER_CONFIG:
			return {...state, ...action.config};

		default:
			return state;
	}
};
